module.exports = __webpack_public_path__ + "ath_game_web/img/6.1.d649ed40.png";